var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './Accordion.module.scss';
import { ArrowDown } from '../../assets/icons';
var Accordion = function (_a) {
    var children = _a.children, title = _a.title, headerContent = _a.headerContent, opened = _a.opened, id = _a.id, className = _a.className, dataId = _a.dataId, onChange = _a.onChange;
    var onAccordionChange = function () {
        onChange(!opened);
    };
    return (_jsxs("section", __assign({ id: id, className: "".concat(styles.Accordion, " ").concat(className ? className : ''), "data-testid": dataId }, { children: [_jsxs("section", __assign({ className: styles.Header, onClick: onAccordionChange, "data-testid": 'accordion-header' }, { children: [_jsxs("div", __assign({ className: styles.Title }, { children: [_jsx(ArrowDown, { className: styles.Arrow }), title && _jsx("h4", { children: title })] })), headerContent] })), opened && _jsx("section", { children: children })] })));
};
Accordion.propTypes = {
    title: PropTypes.string,
    opened: PropTypes.bool.isRequired,
    id: PropTypes.string,
    className: PropTypes.string,
    dataId: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
Accordion.defaultProps = {
    opened: false,
};
export { Accordion };
//# sourceMappingURL=Accordion.js.map